import { useEffect, useState } from "react";
import { withTranslation } from "react-i18next";
import { useParams } from "react-router-dom";
import PostUpdate from "../../components/PostUpdate";
import { backendUrl } from "../../constants";
import JobCard from "../../pages/Search/JobCard";
import "./styles.css";

const Index = ({}) => {
  const { companyId } = useParams();
  const [posts, setPosts] = useState([]);
  const [reload, setReload] = useState(false);
  //posts
  useEffect(() => {
    setPosts([]);
    const options = {
      method: "GET",
    };

    fetch(`${backendUrl}job/listEmployeeJobs/${companyId}/active/1/100`, options)
      .then((response) => response.json())
      .then((response) => {
        response.data.map((obj) => {
          let a = {
            key: obj?._id,
            appliedCandidates: obj?.appliedCandidates,
            title: obj?.jobTitle,
            logo: obj?.attachedFiles[0]?.filePath,
            company: obj?.createdBy?.companyName,
            description: obj?.jobDescription,
            location: obj?.empLocation?.city,
            date: obj?.createdDate,
            remote: obj?.remotely,
          };
          setPosts((p) => [...p, a]);
        });
      })
      .catch((err) => console.error(err));
  }, [companyId, reload]);

  return (
    <div className="d-flex flex-column gap-2 w-75 m-auto">
      <h5 className="text-dark text-center">Post Updates</h5>
      {posts.length ? (
        posts.map((obj, ind) => (
          <JobCard data={obj} key={ind} setReload={setReload} />
        ))
      ) : (
        <h2 className="text-dark text-center">No Jobs Found</h2>
      )}
    </div>
  );
};
export default withTranslation()(Index);
